var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 146,
    viewBox: "0 0 145 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_915_3894",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 73,
    y: 2,
    width: 72,
    height: 142
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.471 143.588C82.7408 143.588 91.9198 141.762 100.484 138.215C109.048 134.667 116.83 129.468 123.384 122.913C129.939 116.359 135.139 108.577 138.686 100.013C142.233 91.4486 144.059 82.2696 144.059 72.9998C144.059 63.73 142.233 54.551 138.686 45.9868C135.139 37.4227 129.939 29.6411 123.384 23.0864C116.83 16.5316 109.048 11.3322 100.484 7.78477C91.9198 4.23739 82.7408 2.41158 73.471 2.41158L73.4711 72.9998L73.471 143.588Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_915_3894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.8064 72.9997C82.6064 73.719 84.3236 74.7137 85.8948 75.9836L90.5826 79.7727C95.225 83.5252 97.9228 89.1747 97.9228 95.144L97.9228 105.47L49.0178 105.47L49.0178 95.144C49.0179 89.1747 51.7157 83.5252 56.3581 79.7727L61.0459 75.9836C62.6168 74.7139 64.3336 73.7194 66.1332 73.0001C64.3332 72.2808 62.616 71.2861 61.0448 70.0162L56.357 66.2271C51.7146 62.4746 49.0168 56.8251 49.0168 50.8558L49.0168 40.5293L97.9217 40.5293L97.9217 50.8558C97.9217 56.8251 95.2239 62.4746 90.5815 66.2271L85.8937 70.0162C84.3228 71.2859 82.606 72.2804 80.8064 72.9997Z",
    fill: "#007BFF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0168 40.5293L49.0168 50.8558C49.0168 56.8251 51.7146 62.4746 56.357 66.2271L61.0448 70.0162C62.616 71.2861 64.3332 72.2808 66.1332 73.0001C64.3336 73.7194 62.6168 74.7139 61.0459 75.9836L56.3581 79.7727C51.7157 83.5252 49.0179 89.1747 49.0179 95.144L49.0178 105.47L97.9228 105.47L97.9228 95.144C97.9228 89.1747 95.225 83.5252 90.5826 79.7727L85.8948 75.9836C84.3236 74.7137 82.6064 73.719 80.8064 72.9997C82.606 72.2804 84.3228 71.2859 85.8937 70.0162L90.5815 66.2271C95.2239 62.4746 97.9217 56.8251 97.9217 50.8558L97.9217 40.5293M49.0168 40.5293L97.9217 40.5293M49.0168 40.5293L43.8236 40.5293M97.9217 40.5293L103.118 40.5293M43.8236 105.47L103.118 105.47",
    stroke: "#007BFF",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2124 105.471L102.47 105.471M43.2124 40.5294L102.47 40.5294M111.986 105.471L32.9763 105.471L32.9763 60.2941L111.986 60.2941L111.986 105.471ZM72.8407 65.9412L48.4034 85.7059L48.4034 125.235L72.8407 145L97.2779 125.235L97.2779 85.7059L72.8407 65.9412ZM111.985 40.5294L32.9752 40.5294L32.9752 85.7059L111.985 85.7059L111.985 40.5294ZM72.8395 80.0588L48.4023 60.2941L48.4023 20.7647L72.8396 0.999991L97.2768 20.7647L97.2768 60.2941L72.8395 80.0588Z",
    stroke: "#007BFF",
    strokeWidth: 1.6875,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.25 5.62"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.52b40fadfac2d36f092bdb923a2f80ac.svg";
export { ForwardRef as ReactComponent };